/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum StaffCapability {
    ENABLED = 'enabled',
    PARTIAL = 'partial',
    DISABLED = 'disabled',
}
